import { APP_NAME } from 'src/js/constants/common';
import track from '../helpers/track';
import eventTypes from '../constants/event-types';

const trackSiteSetupLoadMoreTemplatesClicked = ({
  siteId,
  stepId,
  businessCategory = null,
  archetypeId,
}) => {
  track(eventTypes.SITESETUP_LOAD_MORE_TEMPLATES_CLICKED, {
    appName: APP_NAME,
    siteId,
    stepId,
    businessCategory,
    archetypeId,
  });
};

export default trackSiteSetupLoadMoreTemplatesClicked;
